import { Box, Paper, Typography } from '@mui/material'
import theme from 'src/styles/theme'

interface ContainerCharacteristicsProps {
  children: React.ReactNode,
  label: string
  width: string
}

const ContainerCharacteristics: React.FC<ContainerCharacteristicsProps> = ({
  children,
  label,
  width,
}) => (
  <Box
    component={Paper}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      borderRadius: '8px',
      width,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.blue,
        color: theme.colors.white,
        height: '57px',
        borderRadius: '8px 8px 0 0',
        fontWeight: 'bold',
        marginBottom: '1rem',
      }}
    >
      <Typography>{label}</Typography>
    </Box>
    {children}
  </Box>
)

export default ContainerCharacteristics
